import axios from "../axiosInstance";
import { FetchUserAppSettingsResponse } from "./types";

export const fetchUserAppSettings =
  async (): Promise<FetchUserAppSettingsResponse> => {
    const response = await axios.get<FetchUserAppSettingsResponse>(
      "/api/private/user-app-settings",
    );
    return response.data;
  };
